import React, { useState } from "react";
import { Stack } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Breakpoint } from "../../hooks/useBreakpoint";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { leagueManagementActions } from "../../features/leaguemgmt/leagueManagementSlice";
import PlayoffButtonsModal from "./PlayoffButtonsModal";
import IndividualLeagueSidebarButtons from "./IndividualLeagueSidebarButtons";

const LeagueManagementSidebar = ({
    breakpoint,
    toggleNavbar,
    horizontal = false,
}: {
    breakpoint: Breakpoint;
    toggleNavbar: () => void;
    horizontal?: boolean;
}): React.JSX.Element => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    let league: number | undefined;

    const routePrefix = "/league-management";
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalLeagueId, setModalLeagueId] = useState<number>();
    const [modalAction, setModalAction] = useState<"assign" | "reset">(
        "assign",
    );

    const leaguePattern = /league-management\/league\/(\d+)/;
    const isOnLeaguePage = leaguePattern.test(location.pathname);
    const match = leaguePattern.exec(location.pathname);

    const state = useAppSelector(state => state.leaguemanagement);

    if (!state.selectedLeague) {
        if (match) {
            league = parseInt(match![1]);
            dispatch(leagueManagementActions.setSelectedLeague(league));
        } else {
            league = undefined;
        }
    } else {
        league = state.selectedLeague;
    }

    return (
        <>
            <Stack
                gap={2}
                direction={horizontal ? "horizontal" : "vertical"}
                className={`d-flex ${horizontal ? "flex-wrap justify-content-center" : ""}`}
            >
                <Link
                    to={`${routePrefix}`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    League Home
                </Link>
                {isOnLeaguePage && league && (
                    <>
                        <IndividualLeagueSidebarButtons
                            breakpoint={breakpoint}
                            league={league}
                            routePrefix={routePrefix}
                            setModalAction={setModalAction}
                            setModalLeagueId={setModalLeagueId}
                            setShowModal={setShowModal}
                            toggleNavbar={toggleNavbar}
                        />
                        <hr />
                    </>
                )}
                <Link
                    to={`${routePrefix}/organizations`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Organizations
                </Link>
                <Link
                    to={`${routePrefix}/placement-results`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Placement Results
                </Link>
                <Link
                    to={`${routePrefix}/coiApproval`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    COI Approvals
                </Link>
                <Link
                    to={`${routePrefix}/fields`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Field Locations
                </Link>
                <Link
                    to={`${routePrefix}/looking-for-players`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Looking for Players
                </Link>
                <Link
                    to={`${routePrefix}/tryouts`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Tryouts
                </Link>
                <Link
                    to={`${routePrefix}/game-logs`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Game Logs
                </Link>
                <Link
                    to={`${routePrefix}/ratings/coach`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Coach's Ratings
                </Link>
                <Link
                    to={`${routePrefix}/ratings/umpire`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Umpire Ratings
                </Link>
                <Link
                    to={`${routePrefix}/league-registrations`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    League Registrations
                </Link>
                <Link
                    to={`${routePrefix}/products`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Product Management
                </Link>
                <Link
                    to={`${routePrefix}/promo-codes`}
                    className="btn btn-primary"
                    onClick={toggleNavbar}
                >
                    Promo Codes
                </Link>
            </Stack>
            <PlayoffButtonsModal
                action={modalAction}
                leagueId={modalLeagueId as number}
                showModal={showModal}
                setShowModal={setShowModal}
            />
        </>
    );
};

export default LeagueManagementSidebar;
